// extracted by mini-css-extract-plugin
export var container = "_qp-0";
export var table = "_qp-2";
export var tableWrapper = "_qp-1";